export const APP_ROOT_ID = 'ecard-info-app';

export const ERROR_ID_INVALID_URL = 'IL15';
export const ERROR_ID_EXPIRED_CARD = 'IL17';
